import {CirclesFour, ClipboardText, User} from "@phosphor-icons/react";

export const AssessmentsAdminMenuOptions = [
  {
    name: 'Employees',
    icon: <User size={24} color="#212121"/>,
    link: '/assessments/employees'
  },
  {
    name: 'Dashboard',
    icon: <CirclesFour size={24} color="#212121"/>,
    link: '/assessments/dashboard'
  },
  {
    name: 'Assessment',
    icon: <ClipboardText size={24} color="#212121"/>,
    link: '/assessments/assessment'
  }
]